enum ViewMode {
  GUIDES = "guides",
  USERS = "users",
  MY = "my",
}

export default ViewMode;
